jQuery(document).ready(function ($) {
    const swiperInfoTiles = new Swiper(".info-tiles", {
        slidesPerView: 1,
        spaceBetween: 16,
        autoHeight: true,
        cssMode: true,
        keyboard: true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            420: {
                slidesPerView: 1,
            },
        },
    });
});
